import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between p-4 border-b" }
const _hoisted_2 = { class: "flex items-start gap-2" }
const _hoisted_3 = { class: "text-sm text-white m-0 font-medium" }
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-white m-0 font-medium"
}
const _hoisted_5 = { class: "text-xs pt-3 text-zinc-300" }
const _hoisted_6 = {
  key: 0,
  class: "grid"
}
const _hoisted_7 = { class: "text-zinc-400 text-xs" }
const _hoisted_8 = { class: "flex gap-1 pt-1" }

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import Button from '@/components/ui/button/Button.vue';
import { useAuth } from '@/composables/useAuth';
import { ProfileMediaTypeEnum } from '@/enums/profiles/ProfileMediaTypeEnum';
import { LessonComment } from '@/interfaces/lesson/LessonComment';
import { Pencil, Reply, ThumbsUp, Trash2 } from 'lucide-vue-next';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LessonComment',
  props: {
    comment: {},
    instructorName: {}
  },
  emits: ['edit', 'delete'],
  setup(__props: any) {

const props = __props

const { userAuthenticated } = useAuth()
const avatar = computed(() =>
  props.comment.author.media.find((m) => m.type === ProfileMediaTypeEnum.AVATAR)
);
const isInstructor = computed(() => !!props.instructorName && props.comment.author.name === props.instructorName)

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Avatar), null, {
        default: _withCtx(() => [
          (avatar.value)
            ? (_openBlock(), _createBlock(_unref(AvatarImage), {
                key: 0,
                src: avatar.value.bucketLocation,
                alt: _ctx.comment.author.name
              }, null, 8, ["src", "alt"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(AvatarFallback), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.comment.author.name.split(' ').map(word => word.charAt(0).toUpperCase()).join('')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        (isInstructor.value)
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: { name: 'profile', params: { profileId: _ctx.comment.author.uuid } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.comment.author.name), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("h6", _hoisted_4, _toDisplayString(_ctx.comment.author.name), 1)),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.comment.content), 1)
      ])
    ]),
    (_ctx.comment.userId == _unref(userAuthenticated).userId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(new Date(_ctx.comment.createdAt).toLocaleDateString()), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
            }, [
              _createVNode(_unref(Pencil), { class: "w-4 h-4" })
            ]),
            _createElementVNode("button", {
              class: "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 w-10 rounded-lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete')))
            }, [
              _createVNode(_unref(Trash2), { class: "w-4 h-4" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})